module.exports = __webpack_public_path__ + "img/凌烟阁大画谱（黄庭坚体）白.5f4c83b2.png";